// extracted by mini-css-extract-plugin
export var clauseRow = "_b1-6";
export var emptyState = "_b1-b";
export var filterContent = "_b1-a";
export var filterGroup = "_b1-1";
export var filterGroupContainer = "_b1-0";
export var nestedGroup = "_b1-2";
export var nestedGroupDepth1 = "_b1-3";
export var nestedGroupDepth2 = "_b1-4";
export var nestedGroupDepth3 = "_b1-5";
export var operatorAnd = "_b1-8";
export var operatorOr = "_b1-9";
export var operatorToggle = "_b1-7";
export var removeGroupButton = "_b1-c";